<template>
	<div class="stu_wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
		<div class="stu_cont">
			<div class="top_title">
				<div class="goback" @click="goBack()"><img src="../../../../../static/images/course/icon-3.png"/><span>返回</span></div>
				<i></i>
				<b>学员管理</b>
			</div>
			<h3>{{$route.query.className}}</h3>
			<div class="ipt">
				<div class="seach_ipt">
					<el-input v-model="nameSum" placeholder="请输入姓名/学号/手机号" @keyup.enter.native="sreach()"></el-input>
					<div class="select">
						<span>行政班级</span><i></i>
						<el-select v-model="className" placeholder="请选择" clearable @change="sreach">
					    <el-option
					      v-for="item in options"
					      :key="item"
					      :label="item"
					      :value="item">
					    </el-option>
					  </el-select>
					</div>
					<el-button type="primary" icon="el-icon-search" @click="sreach()">查询</el-button>
				</div>
				<div class="btn">
					<el-button @click="addStudent()">添加</el-button>
					<el-button @click="uploadStudent()" v-show="false">导入</el-button>
					<el-badge :value="waitingListPageTotal" class="item">
					  <el-button size="small" @click="approvedName()">待批名单</el-button>
					</el-badge>
					<el-button size="small" v-if="productFlag == 3 || productFlag == 4" @click="goGroup()">学员分组</el-button>
					<el-button type="primary" @click="batchDelStu()">批量移出</el-button>
				</div>
			</div>
			<div class="table">
				<el-table
			    ref="multipleTable"
			    :data="tableData"
			    tooltip-effect="dark"
			    style="width: 100%"
			    :height="height"
			    :cell-style="cellStyle"
	        :header-cell-style="headerCellStyle"
			    @selection-change="handleSelectionChange">
			    <el-table-column type="selection" width="50"></el-table-column>
			    <el-table-column label="序号" type="index" width="50">
			    	<template slot-scope="scope">{{(pageTotal.currentPage - 1) * pageTotal.pageSize + scope.$index + 1}}</template>
			    </el-table-column>
			    <el-table-column label="姓名" prop="studentName"></el-table-column>
			    <el-table-column label="学号" prop="jobNumber"></el-table-column>
			    <el-table-column label="手机号" prop="mobile">
            <template slot-scope="scope">
              <span style="color: #333333">{{scope.row.mobile | desensitizationText}}</span>
            </template>
          </el-table-column>
			    <el-table-column label="加入方式" prop="joinType">
			    	<template slot-scope="scope">{{ scope.row.joinType == '0'?'录入':'邀请码' }}</template>
			    </el-table-column>
			    <el-table-column label="行政班级" prop="className"></el-table-column>
			    <el-table-column label="操作">
			    	<template slot-scope="scope">
			    		<span @click="delStudent(scope.row)">移出</span>
			    	</template>
			    </el-table-column>
			    <template slot="empty">
	        	<img src="../../../../../static/images/wujieguo.png"/>
	        	<p>暂无学员</p>
	        </template>
			  </el-table>
			  <!-- <pagination
	        :currentpage="pageTotal.currentPage"
	        :limit="pageTotal.pageSize"
	        :total="pageTotal.total"
	        layout="sizes, prev, pager, next, jumper"
	        @handleCurrentChange="handleCurrentChange"
	        @handleSizeChange="handleSizeChange"
	        :small="true"
	        v-if="pageTotal.total>10"
	      ></pagination> -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageTotal.currentPage"
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageTotal.pageSize"
          :pager-count="5"
          layout="sizes, prev, pager, next"
          :total="pageTotal.total"
          class="paginator"
        ></el-pagination>
			</div>
		</div>
		<!--添加学员-->
		<el-dialog title="添加学生" width="982px" :visible.sync="centereDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" :before-close="add_all_student_cancel">
      <div class="sudent-contents">
        <!-- 待选 -->
        <div class="sudent-content">
          <div class="selected tobe">
            <div class="seach">
              <span>待选</span>
              <div class="training-site">
                <el-input
                  v-model="queryVal"
                  placeholder="请输入姓名/学号/手机号/账号"
                  size="mini"
                  style="width: 200px; height: 28px; float: left;"
                  @keyup.enter.native="search_student">
                  <i slot="suffix" @click="search_student" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-select v-model="teachingClass" @change="teachingClassChange" placeholder="请选择教学班" clearable>
			            <el-option
			            v-for="(item,key) in options"
			            :key="key"
			            :label="item"
			            :value="item">
			            </el-option>
			         	</el-select>
              </div>
            </div>
            <div class="left-table">
              <el-table
              	ref="multipleTable2"
                :data="tableData_3"
                :cell-style="cellStyle3"
                :header-cell-style="headerCellStyle3"
                :row-style="{ border: 0 }"
                style="width: 100%;"
                height="256px"
                :row-key="getRowKey"
                @selection-change="check_student"
              >
                <el-table-column width="50" type="selection" align="center" :reserve-selection="true"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="studentNumber" label="学号"></el-table-column>
                <el-table-column prop="teachingClass" label="行政班"></el-table-column>
              </el-table>
            </div>
            <!-- 分页 -->
            <div class="pages">
              <el-pagination
              	@size-change="handleSizeChange2"
              	@current-change="handleCurrentChange2"
              	:current-page.sync="currentPage2"
              	background
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :pager-count="5"
                layout="sizes, prev, pager, next"
                :total="studentTotal"
              ></el-pagination>
            </div>
          </div>
          <!-- button  -->
          <div class="box_button">
            <el-button type="primary" @click="add_active" :disabled="!table_student.length" class="button_top" icon="el-icon-arrow-right" circle></el-button>
            <el-button type="primary" @click="remove_active" :disabled="!table_student2.length" icon="el-icon-arrow-left" circle></el-button>
          </div>
          <!-- 已选 -->
          <div class="selected">
            <div class="seach">
              <span>已选</span>
              <div class="training-site">
                <el-input
                  v-model="queryVal2"
                  placeholder="请输入姓名/学号/手机号/账号"
                  size="mini"
                  style="width: 210px; height: 28px;"
                  @keyup.enter.native="query_student2(queryVal2)">
                  <i slot="suffix" @click="query_student2(queryVal2)" class="el-input__icon el-icon-search"></i>
                </el-input>
              </div>
            </div>
            <div class="">
              <el-table
                :data="tagList"
                :cell-style="cellStyle3"
                :header-cell-style="headerCellStyle3"
                :row-style="{ border: 0 }"
                style="width: 100%;"
                height="301px"
                @selection-change="check_student2"
              >
                <el-table-column width="50" type="selection" align="center"> </el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="studentNumber" label="学号"></el-table-column>
                <el-table-column prop="teachingClass" label="行政班"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="add_all_student_cancel">取 消</el-button>
        <el-button type="primary" @click="add_all_student">确 定</el-button>
      </span>
    </el-dialog>
		<!--表格导入学员-->
		<el-dialog title="导入学生名单" :visible.sync="centerDialogVisibles" :close-on-press-escape="false" :close-on-click-modal="false" width="600px" :before-close="handleCloseUpload">
    	<p class="failMsg" v-if="fail*1 > 0">导入成功{{success}}条，失败{{fail}}条<a target="view_frame" @click="jumpFail()">下载查看错误模板信息</a></p>
      <div class="training-site upload-content">
        <div class="left">
          <el-input :readonly="flag" v-model="fileName"></el-input>
          <span class="on" v-if="fileName" @click="delFile()">删除</span>
          <span class="off" v-else>删除</span>
          <p><i>*</i>注意：</p>
          <p>1.请使用模板文件导入<a target="view_frame" @click="jump()">下载模板</a></p>
        </div>
        <div class="right">
          <el-upload
            ref="upload"
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :before-upload="beforeUpload"
            :show-file-list=false
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList">
           	<img src="../../../../../static/images/wenjianjia.png"/>
            <p>选择文件</p>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleTrainingeSites(false)">取 消</el-button>
        <el-button type="primary" @click="handleTrainingeSites(true)">保 存</el-button>
      </span>
    </el-dialog>
    <!--待批名单-->
    <el-drawer
		  title="待批名单"
		  :visible.sync="drawer"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :with-header="false">
		  <div class="drawer_content">
		  	<header>
		  		<span>待批名单</span><img @click="close()" src="../../../../../static/images/close.png"/>
		  	</header>
		  	<div class="btn_block">
		  		<el-button type="primary" @click="batchDel()">批量拒绝</el-button>
		  		<el-button @click="batchAdopt()">批量通过</el-button>
		  	</div>
		  	<div class="table_block">
		  		<el-table
		  			ref="approvedTable"
            :data="approvedList"
            :cell-style="cellStyle4"
            :header-cell-style="headerCellStyle4"
            :row-style="{ border: 0 }"
            style="width: 100%;"
            :height="(approvedHeight - 200)"
            @selection-change="check_student3"
          >
            <el-table-column width="50" type="selection" align="center"> </el-table-column>
            <el-table-column prop="studentName" label="学员姓名" width="100"></el-table-column>
            <el-table-column prop="jobNumber" label="学号" width="180"></el-table-column>
            <el-table-column prop="className" label="行政班" width="180"></el-table-column>
            <el-table-column label="操作">
            	<template slot-scope="scope">
				    		<span @click="adopt(scope.row)">通过</span>
				    		<span @click="refuse(scope.row)">拒绝</span>
				    	</template>
            </el-table-column>
            <template slot="empty">
            	<img src="../../../../../static/images/wujieguo.png"/>
            	<p>暂无待批名单</p>
            </template>
          </el-table>
          <el-pagination
            @size-change="WaitingListSizeChange"
            @current-change="WaitingListCurrentChange"
            :current-page.sync="waitingListPageNum"
            background
            :page-sizes="[10, 20, 50, 100]"
            :page-size="waitingListPageSize"
            :pager-count="5"
            layout="sizes, prev, pager, next"
            :total="waitingListPageTotal"
            class="paginator"
          ></el-pagination>
		  	</div>
		  </div>
		</el-drawer>
	</div>
</template>

<script>
  import Pagination from "../../../paginator/paginator.vue";
	import * as api from "../../../../api/individualApi";
  import {desensitization} from "@/utils/utils";
	export default {
    filters:{
      desensitizationText(val){
        return desensitization(val)
      }
    },
		components: {
	    Pagination
	  },
		data(){
			return {
				nameSum:'',
				options: [],
        className:'',
        multipleSelection:[],
        approvedSelection:[],
        tableData: [],
        pageTotal: {
	        currentPage: 1,
	        pageSize: 10,
	        total: 0
	      },
	      centereDialogVisible:false,
	      queryVal:'',
	      queryVal2:'',
	      teachingClass:'',
	      teachingClassList:[],
	      studentTotal: 0, //添加学生列表长度
	      currentPage2: 1,
	      addStudentList:[],
	      tableData_3: [], // 学生列表
	      tagList: [],
	      table_student: [], //  选中学生列表 待选
      	table_student2: [], //  选中学生列表  选中
      	list_st: [],
      	centerDialogVisibles: false,
      	success:'',
	      fail:'',
	      uploadUrl:'',
	      flag:true,
	      fileName:'',
	      fileList:[],
	      loading: true,
	      height: null,
	      approvedHeight: window.innerHeight,
	      drawer: false,
	      direction: 'rtl',
	      approvedList: [],
        pageSize:10,
        waitingListPageNum: 1,//待批名单选中页
        waitingListPageSize: 10,//待批名单每页条数
        waitingListPageTotal: 0,//待批名单总条数
        productFlag: sessionStorage.getItem('productFlag')
			}
		},
		created(){
			this.getStudentList();
			this.getTeachingClass();
			this.getApprovedList();
		},
		methods:{
			// 获取学生列表
			getStudentList(){
				let obj = {
					"param": this.nameSum,
					"className": this.className,
					"classId": this.$route.query.classId,
					"page": this.pageTotal.currentPage,
					"limit": this.pageTotal.pageSize,
					"status": 1
				}
				api.getStudentList(obj).then(res=>{
					if(res.code == 0){
						this.loading = false;
						this.tableData = res.data.list;
						this.pageTotal.total = res.data.total;
						this.pageTotal.currentPage = res.data.pageNum;
						if(res.data.total > 10){
							this.height = window.innerHeight - 290+"px";
						}else{
							this.height = window.innerHeight - 240+"px";
						}
					}else{
						this.loading = false;
						this.$messageError(res.msg);
					}
				}).catch(error => {});
			},
			handleCurrentChange(val) {
	      this.pageTotal.currentPage = val;
	      this.getStudentList();
	   	},
	   	handleSizeChange(val){
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.getStudentList();
	   	},
	   	// 获取行政班级
	   	getTeachingClass(){
	   		api.getTeachingClass().then(res=>{
	   			if(res.code == 0){
	   				this.options = res.data;
	   			}
	   		})
	   	},
	   	// 删除学员
	   	delStudent(row){
	   		this.$tipsDialog(
					"提示",
      		"确定移出该学员吗？",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
				).then(() => {
					let arr = [];
					arr.push(row.userId);
	   			let param = {
	   				"classId": this.$route.query.classId,
	   				"userIds": arr
	   			};
					api.delBatchStudent(param).then(res=>{
			  		if(res.code == 0){
              if(this.pageTotal.currentPage!=1){
                if(this.tableData.length==1){
                  this.handleCurrentChange(this.pageTotal.currentPage-1)
                }else{
                  this.handleCurrentChange(this.pageTotal.currentPage)
                }
              }else{
                this.handleCurrentChange(1)
              }
			  			this.$messageSuccess('移出成功');
			  		}else{
			  			this.$messageError(res.msg);
			  		}
			  	}).catch(error => {});
       	}).catch(() => {});
	   	},
	   	// 批量删除学员
	   	batchDelStu(){
        let that = this
	   		if(that.multipleSelection.length){
	   			that.$tipsDialog(
						"提示",
	      		"确定移出选中的学员吗？",
				    "",
				    "el-icon-warning",
				    "rgb(255, 178, 60)"
					).then(() => {
						let arr = [];
		   			that.multipleSelection.forEach(item=>{
		   				arr.push(item.userId)
		   			})
		   			let param = {
		   				"classId": that.$route.query.classId,
		   				"userIds": arr
		   			};
		   			api.delBatchStudent(param).then(res=>{
		   				if(res.code == 0){
		   					if(that.pageTotal.currentPage!=1){
                  if(that.tableData.length==1){
                    that.handleCurrentChange(that.pageTotal.currentPage-1)
                  }else{
                    that.handleCurrentChange(that.pageTotal.currentPage)
                  }
                }else{
                  that.handleCurrentChange(1)
                }
		   					that.$messageSuccess('移出成功');
		   				}else{
		   					that.$messageError(res.msg);
		   				}
		   			})
	       	}).catch(() => {});

	   		}else{
	   			this.$message.warning('请先选择要移出的学员');
	   			return
	   		}
	   	},
			// 返回
			goBack() {
				this.$store.state.activeName = this.$route.query.index;
				this.$router.go(-1);
     	},
	    // 查询
	    sreach(){
        this.loading = true;
	     	this.handleCurrentChange(1)
	    },
	    handleSelectionChange(val) {
        this.multipleSelection = val;
     	},
	    // 添加学员
	    addStudent(){
	     	this.centereDialogVisible = true;
	     	this.teachingClass = '';
	      this.tagList = [];
	      this.queryVal=''
	      this.queryVal2 = ''
	      this.query_student();
	      this.getTeachingClass();
	      this.pageSize = 10;
	     	this.$nextTick(()=>{
	     		this.$refs.multipleTable2.clearSelection()
	     	})
	    },
	    teachingClassChange(val){
	    	this.teachingClass = val;
	    	this.query_student();
	    },
	    check_student(list){
	      // 选中待选
	      this.table_student = list
	    },
	    getRowKey(row){
	    	return row.id
	    },
	    add_active(){
	      // 添加到选中
	      this.tagList = [];
	      this.addStudentList = [];
	      this.list_st = [];
	      this.table_student.forEach((item)=>{
	        this.tagList.push(item);
	        this.list_st.push(item);
	        this.addStudentList.push(item)
	      })
	      this.table_student = [];
	      this.query_student();
	    },
	    remove_active(){
	      // 删除选中
	      this.table_student2.forEach(items => {
	        this.tagList.forEach((item,i) => {
	          if (items.id == item.id) {
	            this.tagList.splice(i,1);
	            this.list_st.splice(i,1);
	          }
	        });
	        this.addStudentList.forEach((item,i) => {
	          if (items.id == item.id) {
	            this.addStudentList.splice(i,1);
	          }
	        });
	      });
	      this.table_student2 = [];
	      this.query_student();
	    },
	    add_all_student_cancel(){
	      this.centereDialogVisible = false
	      this.queryVal=''
	      this.queryVal2 = ''
	      this.currentPage2=1
	      this.addStudentList = []
	      this.query_student();
	      this.pageSize = 10;
	      this.$refs.multipleTable2.clearSelection()
	    },
	    add_all_student(){
	      if(this.addStudentList.length){
	        let userIds = [];
	        for(var i = 0; i < this.addStudentList.length; i++){
	          userIds.push(this.addStudentList[i].id);
	        }
	        let data = {
	          classId: this.$route.query.classId,
	          courseId: this.$route.query.courseId,
	          userIds
	        }
	        api.addStudentInto(data).then((data)=>{
	          if(data.code == 0){
	            this.centereDialogVisible = false;
	            this.$messageSuccess('添加成功')
	            this.getStudentList();
	            this.tagList = [];
	            this.list_st = [];
	            this.addStudentList = []
	          }else{
	            this.$messageInfo(data.msg);
	          }
	        },(e)=>{
	          this.$messageError(e)
	        })
	      }else{
	        this.$messageInfo('请选择')
	      }
	    },
	    query_student2(val){
	      let	choice_list = [];
	      if(val){
	        this.tagList = [];
	        let _this = this;
	        let	choice_list = this.list_st.filter(function(item) {
	          if(item.name.indexOf(val) != -1 || item.studentNumber.indexOf(val) != -1 || (item.mobile&&(item.mobile.indexOf(val) != -1)) || item.userName.indexOf(val) != -1){
	            _this.tagList.push(item)
	            return item;
	          }
	        })
	      }else{
	        this.tagList = this.list_st;
	      }
	    },
	    cellStyle3(data) {
	      if(data.columnIndex == 0){
	        return "text-algin:center !important;"
	      }else{
	        return "text-align:left !important;padding-left: 20px!important;"
	      }
	    },
	    headerCellStyle3({ row, column, rowIndex, columnIndex }) {
	      if (rowIndex === 0 && columnIndex === 0) {
	        return "background:rgba(83,151,247,0.1);color:#999999;text-algin:center !important;"
	      }else{
	        return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important;padding-left: 20px!important;"
	      }
	    },
	    cellStyle4(row, column, rowIndex, columnIndex) {
	      if(row.columnIndex == 0 || row.columnIndex == 4){
	        return "text-algin:center !important;"
	      }else{
	        return "text-align:left !important;padding-left: 20px!important;"
	      }
	    },
	    headerCellStyle4({ row, column, rowIndex, columnIndex }) {
	      if (rowIndex === 0 && columnIndex === 1) {
	        return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important;padding-left: 20px!important;"
	      }else if(rowIndex === 0 && columnIndex === 2){
	      	return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important;padding-left: 20px!important;"
	      }else if(rowIndex === 0 && columnIndex === 3){
	      	return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important;padding-left: 20px!important;"
	      }else{
	        return "background:rgba(83,151,247,0.1);color:#999999;text-algin:center !important;"
	      }
	    },
	    headerCellStyle({ row, column, rowIndex, columnIndex }){
	    	if (rowIndex === 0 && columnIndex === 0) {
	        return "text-algin:center !important;"
	      }
	    },
	    cellStyle(data){
	    	if(data.columnIndex == 0){
	        return "text-algin:center !important"
	      }
	    },
	    check_student2(list){
      	this.table_student2 = list
    	},
    	handleSizeChange2(val){
			this.currentPage2 = 1;
    		this.pageSize = val;
    		this.query_student();
    	},
    	handleCurrentChange2(val){
    		this.currentPage2 = val;
    		this.query_student();
    	},
    	search_student(){
    		this.currentPage2 = 1;
    		this.query_student();
    	},
	    // 查询所有的学员
	    query_student(){
	    	// 查询学生
	      let that = this;
	      let obj = {
	        limit: this.pageSize,
	        page: that.currentPage2,
	        name: that.queryVal,
	        type: "2",
	        status: "1",
	        teachingClass:this.teachingClass
	      };
	      api.getAllStudent(obj).then(data => {
          if (data.code == 0) {
            let datalist = data.data;
            that.studentTotal = datalist.total;
            that.tableData_3 = [];
            datalist.records.forEach(item => {
              that.tableData_3.push({
                userName: item.userName,
                name: item.name,
                studentNumber: item.studentNumber?item.studentNumber:'--',
                teachingClass: item.teachingClass?item.teachingClass:'--',
                id: item.userId,
                mobile: item.mobile,
              });
            });
            if (that.tagList.length) {
              that.tagList.forEach(items => {
                that.tableData_3.forEach((item,i) => {
                  if (items.id == item.id) {
                    that.tableData_3.splice(i,1);
                  }
                });
              });
              let num = 0
              that.tableData_3.forEach((v,i)=>{
                if(v.flag){
                  num++
                }
              })
              if(num==10){
                this.$refs.multipleTable.toggleAllSelection()
              }
            }
          } else {
            this.$messageInfo('没找到')
          }
        },
        e => {
          this.$messageError(e)
        });
	    },
	    // 导入学生
	    uploadStudent(){
	      this.fileName = '';
	      this.centerDialogVisibles = true;
	      this.fail = '';
	      this.success = '';
	      this.uploadUrl = '';
	    },
	    handleCloseUpload(done){
	      done();
	      this.$refs.upload.clearFiles();
	    },
	    handleExceed(files, fileList) {
	      this.$refs.upload.clearFiles();
	    },
	    beforeUpload(file){
        this.$refs.upload.clearFiles();
        var testmsg=file.name.substring(file.name.lastIndexOf('.')+1);
        const extension = testmsg === 'xls'
        const extension2 = testmsg === 'xlsx'
        if(!extension && !extension2) {
            this.$messageWarning('上传文件只能是 xls、xlsx格式!');
        }else {
            let fd = new FormData();
            fd.append('file', file);
            fd.append('type','2');
            fd.append('classId',this.$route.query.classId);
            fd.append('courseId',this.$route.query.courseId);
            this.file = fd;
            this.fileName = file.name;
        }
        return extension
	    },
	    // 导入学生保存
	    handleTrainingeSites(type){
	      if(type){
	        if(this.fileName){
	          api.uploadStudentInto(this.file).then(res=>{
	            if(res.code == '0'){
	              this.loading = false;
	              this.getStudentList();
	              if(res.data.fail > 0){
	                this.uploadUrl = res.data.url;
	                this.success = res.data.success;
	                this.fail = res.data.fail;
	              }else{
	                this.$messageWarning('导入成功'+res.data.success+'条，失败'+res.data.fail+'条');
	                this.centerDialogVisibles = false;
	              }
	            }else{
	              this.$messageError('导入的模板错误，请重新导入');
	            }
	          })
	        }else{
	          this.$messageError('请导入名单后再保存');
	        }
	      }else{
	        this.$refs.upload.clearFiles();
	        this.centerDialogVisibles = false;
	      }
	    },
	    // 删除导入文件
	    delFile(){
	      this.fileName = '';
	      this.$refs.upload.clearFiles();
	    },
	    // 下载模板
	    jump(){
	      let url = process.env.BAK_NAME+'/excel/%E5%AF%BC%E5%85%A5%E5%AD%A6%E7%94%9F%E6%A8%A1%E6%9D%BF.xlsx';
        this.$downloadFun(url)
	    },
	    jumpFail(){
	      // window.location.href = this.uploadUrl;
        this.$downloadFun(this.uploadUrl)
	    },
	    //获取待批名单
	    getApprovedList(){
	    	let obj = {
	    		"classId": this.$route.query.classId,
					"limit": this.waitingListPageSize,
					"page": this.waitingListPageNum,
					"status": 0
	    	};
    		api.getApprovedList(obj).then(res=>{
	    		if(res.code == 0){
	    			this.waitingListPageTotal = res.data.total;
	    			this.approvedList = res.data.list;
	    		}else{
            this.$messageError(res.msg)
          }
	    	});
	    },
	    // 待批名单
	    approvedName(){
	    	this.drawer = true;
	    	this.getApprovedList();
	    },
	    // 关闭待批名单
	    close(){
	    	this.drawer = false;
	    	this.getApprovedList();
	    	this.getStudentList();
	    },
	    check_student3(val){
	    	this.approvedSelection = val;
	    },
	    // 待批名单批量通过
	    batchAdopt(){
	    	if(this.approvedSelection.length){
	    		let arr = [];
	    		this.approvedSelection.forEach(item=>{
	    			arr.push(item.id)
	    		});
		    	let obj = {
		    		"classId":this.$route.query.classId,
		    		"courseId": this.$route.query.courseId,
		    		"ids": arr
		    	};
		    	api.batchStudent(obj).then(res=>{
		    		if(res.code == 0){
		    			this.$messageSuccess('审批已通过');
		    			this.getApprovedList();
		    		}
		    	})
	    	}else{
	    		this.$messageError('请先选择要通过的名单');
	    		return;
	    	}
	    },
	    // 待批名单单个通过
	    adopt(item){
	    	let arr = [];
	    	arr.push(item.id)
	    	let obj = {
	    		"classId":this.$route.query.classId,
	    		"courseId": this.$route.query.courseId,
	    		"ids": arr
	    	};
	    	api.batchStudent(obj).then(res=>{
	    		if(res.code == 0){
	    			this.$messageSuccess('审批已通过');
	    			this.getApprovedList();
	    		}
	    	})
	    },
	    // 待批名单批量拒绝
	    batchDel(){
	    	if(this.approvedSelection.length){
	    		let arr = [];
	    		this.approvedSelection.forEach(item=>{
	    			arr.push(item.userId)
	    		});
		    	let obj = {
		    		"classId":this.$route.query.classId,
		    		"courseId": this.$route.query.courseId,
		    		"userIds": arr
		    	};
		    	api.batchnoStudent(obj).then(res=>{
		    		if(res.code == 0){
		    			this.$messageSuccess('审批已拒绝');
		    			this.getApprovedList();
		    		}else{
		    			this.$messageError(res.msg);
		    		}
		    	})
	    	}else{
	    		this.$messageError('请先选择要拒绝的名单');
	    		return;
	    	}
	    },
	    // 待批名单单个拒绝
	    refuse(item){
	    	let arr = [];
	    	arr.push(item.userId)
	    	let obj = {
	    		"classId":this.$route.query.classId,
	    		"courseId": this.$route.query.courseId,
	    		"userIds": arr
	    	};
	    	api.batchnoStudent(obj).then(res=>{
	    		if(res.code == 0){
	    			this.$messageSuccess('审批已拒绝');
	    			this.getApprovedList();
	    		}else{
	    			this.$messageError(res.msg);
	    		}
	    	})
      },
      //待批名单分页
      WaitingListSizeChange(val){
        this.waitingListPageSize = val
        this.getApprovedList()
    	},
    	WaitingListCurrentChange(val){
        this.waitingListPageNum = val
        this.getApprovedList()
    	},
    	goGroup(){
    		this.$router.push({
      		path:'/groupAdmin',
      		query:{
      			classId: this.$route.query.classId,
      			courseId: this.$route.query.courseId,
      			className: this.$route.query.className,
      			index: 'first',
      			subjectId: this.$route.query.subjectId
      		}
      	})
    	}
		}
	}
</script>

<style scoped lang="scss">
	.stu_wrap {
		background: #F6F8FB;
		.stu_cont {
			margin: 16px;
			margin-bottom: 0;
			background: #fff;
		}
		.top_title {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding: 20px 0;
			margin: 0 16px;
			border-bottom: 1px solid #DDE0E2;
			.goback {
				display: flex;
				align-items: center;
				font-size: 12px;
				cursor: pointer;
				img {
					display: inline-block;
					width: 18px;
					height: 18px;
					margin-right: 8px;
				}
			}
			i {
				width:4px;
				height:12px;
				background:rgba(83,151,247,1);
				margin: 0 10px;
			}
			b {
				font-size: 16px;
				color: #0D141E;
				font-weight: bold;
			}
		}
		h3 {
			font-size: 16px;
			color: #0D141E;
			margin-top: 20px;
			margin-bottom: 16px;
			padding: 0 24px;
			font-weight: bold;
		}
		.ipt {
			display: flex;
			justify-content: space-between;
			padding: 0 20px;
			/deep/ .el-input {
				width: 298px;
				float: left;
				.el-input__inner {
					height: 32px;
					line-height: 32px;
					border: 0;
					background: #F1F2F4;
					border-radius: 2px;
				}
			}
			.select {
				float: left;
				width: 230px;
				height: 32px;
				background: #F1F2F4;
				margin-left: 16px;
				border-radius: 2px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				span {
					font-size: 12px;
					color: #A0A0A6;
					margin-left: 14px;
				}
				i {
					width:0px;
					height:16px;
					border:1px solid rgba(188,188,194,1);
				}
				/deep/ .el-input {
					width: 126px;
					.el-input__icon {
						line-height: 32px;
					}
				}
			}
			/deep/ .el-button {
				padding: 8px 0;
				width: 72px;
				text-align: center;
				margin-left: 14px;
				border-color: #5397F7;
				span {
					font-size: 12px;
				}
			}
			/deep/ .el-button--default {
				span {
					color: #5397F7;
				}
			}
		}
		.table {
			padding: 0 20px;
			/deep/ .el-table {
				td .cell {
					height: 40px;
					line-height: 40px;
					background: #F6F8FB;
					margin-bottom: 8px;
					span {
						cursor: pointer;
						color: #5397F7;
					}
				}
				th {
					.cell {
						background: transparent;
					}
				}
				td,th {
					padding: 0;
					height: 40px;
				}
				/deep/ tr {
					&:hover {
						background: transparent !important;
					}
				}
				td {
					padding-bottom: 8px;
				}
				td,th.is-leaf {
					border: 0;
				}
				th.is-leaf {
					&:nth-child(1) {
						padding-left: 3px;
					}
				}
			}
		}
		.sudent-content{
		  display: flex;
		  justify-content: space-around;
		  .selected{
		    width: 430px;
		    height: 350px;
		    border:1px solid rgba(226,226,226,1);
		    border-radius: 4px;
		    .seach{
		      height: 48px;
		      display: flex;
		      justify-content: space-between;
		      align-items: center;
		      padding: 0 13px 0 12px;
		      .el-select {
		      	width: 160px;
		      	margin-left: 5px;
		      	/deep/ .el-input__inner {
		      		height: 28px;
							line-height: 28px;
		      	}
		      	/deep/ .el-input__icon {
							line-height: 28px;
						}
		      }
		    }
		    /deep/ .el-table{
		      margin: 0 !important;
		      border-left: 0;
		      border-right: 0;
		    }
		  }
		  .tobe{
		    width: 430px;
		  }
		  .box_button{
		    display: flex;
		    flex-direction: column;
		    justify-content: center;
		    .button_top{
		      margin-bottom: 8px;
		    }
		    /deep/ .el-button{
		      padding: 0px 0px;
		      margin-left: 0px;
		      width: 32px;
		      border-radius: 50%;
		      height: 32px;
		      i{
		        color: #fff;
		      }
		    }
		  }
		  /deep/ .el-input__inner{
		    padding-left: 10px;
		  }
		}
		.sudent-contents{
		  .pages{
		    display: flex;
		    align-items: center;
		    border-top: 1px solid #e2e2e2;
		    height: 49px;
		  }
		  /deep/ .el-pagination.is-background{
		    line-height: 26px;
		    .el-pager li, .btn-prev,.btn-next{
		      margin: 0 2px;
		      background-color: #fff;
		      border: 1px solid #e2e2e2;
		      border-radius: 4px;
		      font-size: 12px;
		      font-weight: 400;
		      color: #666;
		      padding: 0 2px;
		    }
		    .el-pager li.active {
		    	background-color: #409EFF;
		    	color: #fff;
		    }
		    .is-in-pagination {
		    	width: 60px;
		    	.el-input__inner {
			    	width: 100%;
			    	padding-left: 3px;
			    }
		    }
		  }
		  /deep/ .el-pagination__jump{
		    margin-left: 4px;
		  }
		}
		/deep/ .el-dialog .el-dialog__header span {
		  display: block;
		  font-size: 14px;
		  font-weight: 400;
		  color: #5397f7;
		  border-left: 2px solid #5397F7;
		  line-height: 10px;
		  padding-left: 5px;
		}
		/deep/ .el-dialog .el-dialog__header {
		  width: 100%;
		  height: 48px;
		  background: #edf4ff;
		  padding: 20px 15px 0 15px;
		  box-sizing: border-box;
		  border-radius: inherit;
		}
		.failMsg {
			color: #F00000;
			text-align: center;
			a {
				cursor: pointer;
				color: #5397F7;
			}
		}
		.upload-content {
		  padding: 90px;
		  display: flex;
		  justify-content: space-between;
		  .el-input {
		    width: 240px;
		    margin-bottom: 16px;
		    /deep/ .el-input__inner {
		      padding-right: 75px;
		      height: 34px;
		      line-height: 34px;
		    }
		  }
		  .left {
		    position: relative;
		    p {
		      font-size: 12px;
		      color: #999999;
		      margin-bottom: 6px;
		      i{
		        color: #E34646;
		      }
		      a {
		        cursor: pointer;
		        color: #5397F7;
		        &:hover {
		            text-decoration: underline;
		        }
		      }
		    }
		    span {
		      position: absolute;
		      width:64px;
		      height:34px;
		      line-height: 34px;
		      text-align: center;
		      border-radius:0px 4px 4px 0px;
		      right: 0;
		      top: 0;
		      color: #FFFFFF;
		    }
		    .off {
		      background:rgba(226,226,226,1);
		    }
		    .on {
		      cursor: pointer;
		      background: #5397F7
		    }
		  }
		  .right {
		    width:88px;
		    height:88px;
		    text-align: center;
		    background:rgba(255,255,255,1);
		    border:1px solid rgba(226,226,226,1);
		    border-radius:4px;
		    img {
		        display: inline-block;
		        width: 32px;
		        height: 32px;
		        margin-top: 16px;
		        margin-bottom: 4px;
		    }
		    p {
		        color: #999999;
		    }
		    .upload-demo {
		        width: 100%;
		        height: 100%;
		    }
		  }
		}
		/deep/ .el-drawer {
			width: 760px !important;
		}
		.drawer_content {
			header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 64px;
				border-bottom: 2px solid #DDE0E2;
				padding: 0 20px;
				span {
					font-size: 16px;
					color: #0D141E;
				}
				img {
					display: block;
					width: 26px;
					height: 26px;
					cursor: pointer;
				}
			}
			.btn_block {
				margin-top: 26px;
				margin-bottom: 18px;
				padding: 0 34px;
				text-align: right;
				.el-button {
					margin-left: 20px;
					padding: 9px 11px;
				}
			}
			.table_block {
				padding: 0 34px;
				/deep/ .el-table__empty-text {
					img {
						display: inline-block;
						width: 165px;
						height: 165px;
					}
					p {
						font-size: 14px;
						color: #5D646E;
					}
				}
				/deep/ .el-table {
					th {
						text-align: center;
					}
					tr {
						td {
							&:last-child {
								text-align: center;
								.cell {
									display: flex;
									justify-content: space-around;
									span {
										cursor: pointer;
										&:hover {
											color: #5397F7;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/components/studentAdmin.vue